import { gql } from '@apollo/client';

/**
 * Alta de empresa externa.
 *
 * Desde 2026-07 solo se llama desde el módulo de Gestión: el wizard de
 * Actuación ya no da de alta empresas en el catálogo maestro, y el backend
 * además lo deniega a tablet/room-team/operating-team.
 *
 * El backend rechaza duplicados por nombre NORMALIZADO (minúsculas, sin
 * espacios) con EXTERNAL_COMPANY_DUPLICATE_NAME.
 *
 * ⚠️ El operationName sigue siendo `createExternalCompany` — los mocks E2E
 * dependen de él.
 */
export const CREATE_EXTERNAL_COMPANY = gql`
  mutation createExternalCompany($companyName: String!) {
    createOneExternalCompany(companyName: $companyName) {
      id
      companyName
      isActive
      externalWorksCount
    }
  }
`;

export const UPDATE_EXTERNAL_COMPANY = gql`
  mutation updateExternalCompany($input: UpdateExternalCompany) {
    updateExternalCompany(input: $input) {
      id
      companyName
      isActive
      externalWorksCount
    }
  }
`;

/**
 * Baja lógica. La empresa deja de ofrecerse al crear actuaciones, pero se
 * sigue viendo en las que ya la usan (su nombre se resuelve por id, no por el
 * listado) y en los informes históricos.
 */
export const DEACTIVATE_EXTERNAL_COMPANY = gql`
  mutation deactivateExternalCompany($id: ID!) {
    deactivateExternalCompany(id: $id) {
      id
      isActive
    }
  }
`;

export const ACTIVATE_EXTERNAL_COMPANY = gql`
  mutation activateExternalCompany($id: ID!) {
    activateExternalCompany(id: $id) {
      id
      isActive
    }
  }
`;

/**
 * Borrado DURO. El backend lo rechaza con EXTERNAL_COMPANY_IN_USE si la
 * empresa tiene trabajos externos asociados; ahí la vía es desactivarla.
 */
export const DELETE_EXTERNAL_COMPANY = gql`
  mutation deleteExternalCompany($id: ID!) {
    deleteExternalCompany(id: $id) {
      id
    }
  }
`;
